import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const thermogravimetricAnalysis = {
    jpath: ['spectra', 'thermogravimetricAnalysis'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default thermogravimetricAnalysis;
//# sourceMappingURL=thermogravimetricAnalysis.js.map